export const methods = {
    bookmarks: {
        list: "users.bookmarks.list",
        add: "users.bookmarks.add",
        delete: "users.bookmarks.delete",
        byWord: {
            get: "users.bookmarks.byWord.get"},
        stats: {
            get: "users.bookmarks.stats.get"}},
    profile: {
        get: "users.profile.get",
        achievements: {
            list: "users.profile.achievements.list"},
        activity: {
            list: "users.profile.activity.list"}}};


  export const typedMethods = {};
